"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADT = exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
const adt_1 = require("@morphic-ts/adt");
const Audio = __importStar(require("./Audio"));
const Names = __importStar(require("./Names"));
const Name_1 = require("./Name");
const File = __importStar(require("./File"));
const Format = __importStar(require("./Format"));
const Unknown = __importStar(require("./Unknown"));
const AddOn_1 = require("./AddOn");
exports.Type = prelude_1.t.union([
    Audio.Type,
    File.Type,
    Format.Type,
    Unknown.Type,
    Name_1.FirstName.Type,
    Name_1.SecondName.Type,
    AddOn_1.StarGreeting.Type
]);
exports.ADT = (0, adt_1.unionADT)([prelude_1.adt.fromUnion('class', exports.Type), Names.ADT]);
//# sourceMappingURL=Field.js.map